const splitNetworkName = (name) => {
  // If it is a SH HNO → split by ';'
  if (name.includes(';')) {
    const nameArray = name.split(';').join(';');
    const half = Math.ceil(nameArray.length / 2);

    return [
      nameArray.slice(0, half),
      nameArray.slice(-half),
    ];
  }

  // If longer than 25 chars truncate and add ellipses
  if (name.length > 25) {
    return `${name.slice(0, 25)}...`;
  }

  return name;
};
export { splitNetworkName };
